function normalizeClipboardFile(file, index = 0) {
  if (!file) return null;

  const type =
    file.type ||
    (file.name?.match(/\.(jpe?g|png|gif|webp|bmp)$/i)
      ? `image/${file.name.split(".").pop().toLowerCase().replace("jpg", "jpeg")}`
      : "image/png");

  const ext = type.split("/")[1]?.replace("jpeg", "jpg") || "png";
  const name =
    file.name && file.name.trim() && file.name !== "image.png"
      ? file.name
      : `clipboard-${Date.now()}-${index}.${ext}`;

  if (file.name === name && file.type === type) return file;
  return new File([file], name, { type });
}

export function extractClipboardFiles(clipboardData) {
  if (!clipboardData) return [];

  const fromFiles = clipboardData.files?.length
    ? Array.from(clipboardData.files)
    : [];

  if (fromFiles.length > 0) {
    return fromFiles.map((file, index) => normalizeClipboardFile(file, index)).filter(Boolean);
  }

  const items = clipboardData.items ? Array.from(clipboardData.items) : [];
  const fromItems = [];
  for (const item of items) {
    if (item.kind !== "file") continue;
    const type = item.type || "";
    if (!type.startsWith("image/") && !type.startsWith("video/") && !type.startsWith("audio/")) {
      continue;
    }
    const file = item.getAsFile();
    if (file) fromItems.push(normalizeClipboardFile(file, fromItems.length));
  }
  return fromItems.filter(Boolean);
}
